<template>
  <div class="boday-padding">
    <el-card class="box-card">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="人员">
          <el-select v-model="filterObj.username">
            <el-option label="全部" value="">全部</el-option>
            <el-option :value="itme.truename" v-for="(itme, index) in FenFaList" :label="itme.truename" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录音类型">
          <el-select v-model="filterObj.Typename">
            <el-option label="全部" value="">全部</el-option>
            <el-option :value="itme.typeName" v-for="(itme, index) in recordTypeList" :label="itme.typeName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="filterObj.Keys" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="线索创建时间">
          <el-date-picker style="width:250px" v-model="filterObj.uploadTime" type="daterange" value-format="yyyy-MM-dd"
            range-separator="至" clearable start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="TimeBtn">
            <p :class="{ BackgroundP: TimeBtn == 'day' }" @click="TimeBtnHandel('day')">
              今日
            </p>
            <p :class="{ BackgroundP: TimeBtn == 'week' }" @click="TimeBtnHandel('week')">
              本周
            </p>
            <p :class="{ BackgroundP: TimeBtn == 'month' }" @click="TimeBtnHandel('month')">
              本月
            </p>
          </div>
        </el-form-item>
        <el-form-item label="最后一次邀约时间">
          <el-date-picker style="width:250px" v-model="filterObj.time" type="daterange" value-format="yyyy-MM-dd"
            range-separator="至" clearable start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="getTableData">查 询</el-button>
          <el-button type="primary" size="small" icon="el-icon-download" @click="download">下 载</el-button>
          <el-button type="primary" size="small" icon="el-icon-refresh" @click="resetSearch">重 置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <el-table :data="tableData" :header-cell-style="{ 'background-color': '#f0f3f5' }" size="mini"
        tooltip-effect="dark" style="width: 100%">
        <el-table-column prop="Customerphone" label="客户电话" align="center" width="120"></el-table-column>
        <el-table-column prop="Customername" label="客户姓名" align="center"></el-table-column>
        <el-table-column prop="Typename" label="录音类型" align="center" width="108"></el-table-column>
        <el-table-column prop="createdtime" label="线索创建时间" align="center" width="108"></el-table-column>
        <el-table-column prop="call_count" label="邀约次数" align="center"></el-table-column>
        <el-table-column prop="username" label="邀约人员" align="center"></el-table-column>
        <el-table-column prop="firsttime" label="首次邀约时间" align="center" width="108"></el-table-column>
        <el-table-column prop="lastupdatetime" label="最后邀约时间" align="center" width="108"></el-table-column>
        <el-table-column prop="ownerwords" label="意向车系" align="center"></el-table-column>
        <el-table-column prop="longtime" label="邀约时长(分)" align="center" width="110"></el-table-column>
        <el-table-column prop="score" label="邀约评分" align="center"></el-table-column>
        <el-table-column label="邀约有效性" align="center">
          <template slot-scope="scope">
            {{ scope.row.scorevalid == 1 ? "有效" : "无效" }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="detail-btn">
              <i class="el-icon-view" @click="openDetail(scope.row)"></i>
              <i class="el-icon-edit" @click="edit(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="filterObj.pageno"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :visible.sync="editVisible" width="60%" :show-close="false">
      <div>
        <div class="hasInput">
          <span>客户姓名</span>
          <el-input v-model="editData.Customername" placeholder="请输入客户姓名" size="small"></el-input>
        </div>
        <div class="hasInput">
          <span>客户电话</span>
          <el-input v-model="editData.Customerphone" placeholder="请输入客户电话" disabled size="small"></el-input>
        </div>
        <div class="hasInput">
          <span>关注车系</span>
          <el-select v-model="editData.ownerwords" size="small" placeholder="请选择车系" @change="getCarModelList">
            <el-option :label="item.ownerwords" :value="item.ownerwords" v-for="(item, index) in carTypeList"
              :key="index"></el-option>
          </el-select>
          <el-select v-model="editData.model" size="small" placeholder="请选择车型">
            <el-option :label="item.model" :value="item.model" v-for="(item, index) in carModelList" :key="index">
            </el-option>
          </el-select>
        </div>
        <div class="hasInput">
          <span>购车预算</span>
          <el-input v-model="editData.budget" placeholder="请输入购车预算" size="small"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="editMore">
          <span>创建人员：{{ editData.username }}</span>
          <span>创建时间：{{ editData.createdtime }}</span>
        </div>
        <el-button type="info" @click="editVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="detailVisible" width="80%">
      <div>
        <el-table class="detail-table" :data="detail" :header-cell-style="{ 'background-color': '#f0f3f5' }" size="mini"
          style="width: 100%" tooltip-effect="dark" max-height="400">
          <el-table-column label="" width="32">
            <template slot-scope="scope">
              <div class="record-icon">
                <img v-if="scope.row.status == '已接去电'" src="../../assets/imgs/recordIconBlue.png" alt="" />
                <img v-if="scope.row.status == '未接去电'" src="../../assets/imgs/recordIconRed.png" alt="" />
                <img v-if="
                  scope.row.status != '已接去电' &&
                  scope.row.status != '未接去电'
                " src="../../assets/imgs/recordIconGrey.png" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="跟进人员" align="center"></el-table-column>
          <el-table-column label="通话类型" align="center">
            <template slot-scope="scope">
              <span :style="{
                color:
                  scope.row.status == '已接去电'
                    ? '#4B94FF'
                    : scope.row.status == '未接去电'
                      ? '#D31E1E'
                      : '#A8A8A8'
              }">{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="callInTime" label="通话时间" align="center" width="108"></el-table-column>
          <el-table-column label="意向车型" align="center">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.ownerwords" placement="top">
                <el-button>{{
                    scope.row.ownerwords && scope.row.ownerwords.split(",")[0]
                }}</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="longtime" label="通话时长(分)" align="center" width="110"></el-table-column>
          <el-table-column prop="score" label="跟进评分" align="center"></el-table-column>
          <el-table-column label="跟进有效性" align="center">
            <template slot-scope="scope">
              <span :style="{
                color: scope.row.scorevalid == '1' ? '#4B94FF' : '#727272'
              }">{{ scope.row.scorevalid == 1 ? "有效" : "无效" }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <div class="detail-btn" v-if="
                scope.row.status == '已接来电' ||
                scope.row.status == '已接去电'
              ">
                <i class="el-icon-view" @click="OperationHandel('find', scope.row)"></i>
                <i class="el-icon-download" @click="OperationHandel('download', scope.row)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      filterObj: {
        username: "", //人员
        keywords: "", //关键字
        Typename: "", //录音类型
        uploadTime: [],
        time: [],
        t0: "", //上传开始时间（yyyy-MM-dd）
        t1: "", //长传截止时间（yyyy-MM-dd）
        lastt0: "", //最近一次邀约开始时间（yyyy-MM-dd）
        lastt1: "", //最近一次邀约截止时间（yyyy-MM-dd）
        pageno: 1, //请求页数
        pagesize: 10 //每页返回条数
      },
      editData: {},
      recordTypeList: [
        {
          typeName: "DCC呼出"
        },
        {
          typeName: "续保呼出"
        }
      ], //录音类型列表
      carTypeList: [],
      FenFaList: [], //  分发人员列表
      carModelList: [],
      tableData: [],
      detail: [],
      total: 0, // 总数
      editVisible: false,
      detailVisible: false,
      TimeBtn: "month",
      admininfo: {},
      isDistribute: ""
    };
  },
  created() {
    this.admininfo = this.cookieToJson();
    this.isDistribute = this.$route.query.isDistribute || 1;
    this.TimeBtnHandel("week");
    // // 获取录音列表
    // this.FindVadioList()
    // 车系
    this.getCartypelist();
    // 获取分发人员列表
    this.GetFenFaUserName();
  },
  methods: {
    // cookies 转对象
    cookieToJson() {
      let cookieArr = decodeURIComponent(document.cookie.slice(8)).split("&");
      console.log(cookieArr);
      let obj = {};
      cookieArr.forEach(i => {
        let arr = i.split("=");
        obj[arr[0]] = arr[1];
      });
      return obj;
    },
    getTableData() {
      let params = {
        action: "GetClueList",
        username: "", //人员
        keywords: "", //关键字
        t0: "", //上传开始时间（yyyy-MM-dd）
        t1: "", //长传截止时间（yyyy-MM-dd）
        lastt0: "", //最近一次邀约开始时间（yyyy-MM-dd）
        lastt1: "", //最近一次邀约截止时间（yyyy-MM-dd）
        pageno: "", //请求页数
        pagesize: "" //每页返回条数
      };
      // this.$loading({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // });
      params = { ...params, ...this.filterObj };
      console.log(params);
      if (params.uploadTime && params.uploadTime[0]) {
        params.t0 = params.uploadTime[0];
        params.t1 = params.uploadTime[1];
      }
      delete params.uploadTime;
      if (params.time && params.time[0]) {
        params.lastt0 = params.time[0];
        params.lastt1 = params.time[1];
      }
      delete params.time;
      this.$axios.Postdata("Manage/ClueList.aspx", params).then(res => {
        this.tableData = res.data.list;
        this.total = parseInt(res.data.rowCount);
      });
    },
    download() {
      let params = {
        action: "GetClueList",
        action2: "download",
        username: "", //人员
        keywords: "", //关键字
        t0: "", //上传开始时间（yyyy-MM-dd）
        t1: "", //长传截止时间（yyyy-MM-dd）
        lastt0: "", //最近一次邀约开始时间（yyyy-MM-dd）
        lastt1: "" //最近一次邀约截止时间（yyyy-MM-dd）
      };
      params = { ...params, ...this.filterObj };
      if (params.uploadTime && params.uploadTime[0]) {
        params.t0 = params.uploadTime[0];
        params.t1 = params.uploadTime[1];
      }
      delete params.uploadTime;
      if (params.time && params.time[0]) {
        params.lastt0 = params.time[0];
        params.lastt1 = params.time[1];
      }
      delete params.time;
      delete params.pageno;
      delete params.pagesize;
      this.$axios.Postdata("Manage/ClueList.aspx", params).then(res => {
        if (res.data.errcode == 0) {
          window.open(window.location.origin + "/" + res.data.fileurl);
        } else {
          this.$message(res.msg || "网络错误，请重试");
        }
      });
    },
    resetSearch() {
      this.filterObj = {
        username: "", //人员
        keywords: "", //关键字
        uploadTime: [],
        time: [],
        t0: "", //上传开始时间（yyyy-MM-dd）
        t1: "", //长传截止时间（yyyy-MM-dd）
        lastt0: "", //最近一次邀约开始时间（yyyy-MM-dd）
        lastt1: "", //最近一次邀约截止时间（yyyy-MM-dd）
        pageno: 1, //请求页数
        pagesize: 10 //每页返回条数
      };
      let today = new Date(),
        weekDay = today.getDay();
      weekDay == 0 && (weekDay = 7);
      this.TimeBtn = "week";
      this.filterObj.uploadTime = [
        new Date(today - 1000 * 60 * 60 * 24 * (weekDay - 1)).Format(
          "YYYY-MM-DD"
        ),
        today.Format("YYYY-MM-DD")
      ];
    },
    //  日期切换
    TimeBtnHandel(type) {
      let today = new Date(),
        todayStr = today.Format("YYYY-MM-DD");
      if (type == "day") {
        this.filterObj.uploadTime = [todayStr, todayStr];
      } else if (type == "week") {
        let weekDay = today.getDay();
        weekDay == 0 && (weekDay = 7);
        this.filterObj.uploadTime = [
          new Date(today - 1000 * 60 * 60 * 24 * (weekDay - 1)).Format(
            "YYYY-MM-DD"
          ),
          todayStr
        ];
      } else {
        this.filterObj.uploadTime = [
          new Date(today.setDate(1)).Format("YYYY-MM-DD"),
          new Date().Format("YYYY-MM-DD")
        ];
      }
      this.TimeBtn = type;
      this.getTableData();
    },
    edit(_data) {
      this.editData = { ..._data };
      this.editVisible = true;
    },
    //  分页功能
    handleCurrentChange(e) {
      this.filterObj.pageno = e;
      this.getTableData();
    },
    // 获取分发人列表
    GetFenFaUserName() {
      this.$axios
        .Postdata(
          `manage/Voicerecordreport.asmx/getusermember`,
          {
            cid: this.admininfo.id,
            actname: '',
            tid: ''
          }
        )
        .then(res => {
          console.log(res);
          this.FenFaList = res.data;
        });
    },
    // 获取车系列表
    getCartypelist() {
      this.$axios
        .Postdata("Manage/ClueList.aspx", {
          action: "GetCars",
          cid: this.admininfo.id
        })
        .then(res => {
          //   [{ownerwords: "E-HS3"}, {ownerwords: "E-HS9"}, {ownerwords: "H5"}, {ownerwords: "H7"}]
          this.carTypeList = res.data.list;
        });
    },
    getCarModelList() {
      this.$axios
        .Postdata("Manage/ClueList.aspx", {
          action: "GetModel",
          cid: this.admininfo.id,
          ownerwords: this.editData.ownerwords
        })
        .then(res => {
          this.carModelList = res.data.list;
        });
    },
    submitEdit() {
      let params = {
        action: "UpdateClueInfo",
        clue_id: this.editData.clue_id, //（线索id）
        cid: this.editData.cid, //经销商代码
        Customername: this.editData.Customername, //客户姓名
        ownerwords: this.editData.ownerwords, //意向车系
        model: this.editData.model, //车型
        budget: this.editData.budget //购车预算
      };
      this.$axios.Postdata("Manage/ClueList.aspx", params).then(res => {
        if (res.data.errcode == 0) {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.editVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.msg || "网络错误，请重试");
        }
      });
    },
    openDetail(_item) {
      console.log(_item);
      let params = {
        action: "GetClueInfo",
        cid: _item.cid, //经销商代码
        Customerphone: _item.Customerphone,
        pageno: 1, //请求页数
        pagesize: 99 //每页返回条数
      };
      this.$axios.Postdata("Manage/ClueList.aspx", params).then(res => {
        this.detail = res.data.list;
        this.detailVisible = true;
      });
    },
    OperationHandel(type, data) {
      console.log(data);
      if (type == "find") {
        window.open(
          `${location.origin}/Manage/VadioDetail.html?id=${data.voicerecordsid}&isDistribute=${this.isDistribute}`
        );
      }
      if (type == "download") {
        const a = document.createElement("a");
        a.setAttribute("href", data.FileUrl); //a.href='文件链接'
        a.setAttribute("download", data.FileUrl.split("/").pop()); //a.download='文件名'
        a.click();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.boday-padding {
  padding: 8px;
}

.el-card {
  margin-bottom: 10px;
}

.hasInput {
  position: relative;
  padding-left: 100px;
  margin-bottom: 10px;

  &>span:first-child {
    position: absolute;
    top: 0;
    left: 0;
    line-height: 32px;
  }

  .el-select+.el-select {
    margin-left: 10px;
  }
}

.editMore {
  float: left;
  line-height: 28px;
  font-size: 14px;

  span {
    margin-right: 20px;
  }
}

.detail-btn {
  white-space: nowrap;
  color: #4b94ff;
  font-size: 16px;

  i+i {
    margin-left: 5px;
  }
}

.record-icon {
  text-align: center;

  img {
    width: 14px;
  }
}

.el-icon-view,
.el-icon-edit,
.el-icon-download {
  font-size: 16px;
  cursor: pointer;
}

.el-icon-edit {
  margin-left: 10px;
}

.TimeBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #4a8df0;
  border-radius: 3px;
  cursor: pointer;
}

.TimeBtn p {
  padding: 0;
  margin: 0;
  width: 83px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #4a8df0;
}

.TimeBtn p:nth-of-type(2) {
  border-left: 1px solid #4a8df0;
  border-right: 1px solid #4a8df0;
}

.BackgroundP {
  background-color: #4a8df0;
  color: #fff !important;
}

.iconcss {
  color: #4a8df0;
  cursor: pointer;
}

.iconcss i {
  font-size: 18px !important;
}

.el-dialog__header {
  padding: 20px 20px 20px;
  background-color: #ecf3f8;
}

.el-dialog__body {
  padding-bottom: 0px;
}

.el-dialog__footer {
  padding: 20px 20px 20px;
}

[v-cloak] {
  display: none;
}

.activecss {
  color: #cecece !important;
}
</style>
